import { Expose, Type } from 'class-transformer';

export class TourCategoryModel {
  id: string;
  name: string;
  description: string;

  @Expose({ name: 'admin_commission' })
  @Type(() => Number)
  adminCommission: number;

  @Expose({ name: 'operator_commission' })
  @Type(() => Number)
  operatorCommission: number;

  @Expose({ name: 'sales_commission' })
  @Type(() => Number)
  salesCommission: number;
}

export class TourCategoryLiteModel {
  id: string;
  name: string;
}

//query
export class getTourCategoriesInput {
  params: {
    page: number;
    limit?: number;
    q?: string;
  };
}

export class getTourCategoryInput {
  id: string;
}

//mutation

export class TourCategoryMutationInput {}

export class TourCategoryMutationUpdateInput {
  id: string;
  body: TourCategoryMutationInput;
}

export class TourCategoryMutationDeleteInput {
  id: string;
}
